import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@enlighten/design-system/dist/Box';
import List from '@enlighten/design-system/dist/List';
import ListItem from '@enlighten/design-system/dist/ListItem';
import Stack from '@enlighten/design-system/dist/Stack';
import Typography from '@enlighten/design-system/dist/Typography';
import * as HanwhaTextComponent from '../../assets/images/hanwha/hanwha-text.svg';
const HanwhaText = process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
    process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true'
    ? HanwhaTextComponent.default
    : HanwhaTextComponent.ReactComponent;
const contents = [
    {
        title: '참고사항',
        items: [
            '해당발전소의 정확한 보험료 조회는 영업일 기준 5일 이내의 시간이 소요됩니다.',
            '대출내역이 있는 발전소의 경우 대출내역과 설정할 질권금액을 미리 확인하여 고지해주세요.',
            '하기에 해당하는 발전소는 고객센터로 별도 문의해주세요.',
            `인수여부와 보험료는 개별
  1. ESS 포함 발전사업자
  2. 수상태양광
  3. 재물가액(OMD) 30억 이상의 지붕형 태양광
  4. 사고이력이 있는 태양광
  5. 배상책임 보상한도액 10억 초과`,
        ],
    },
    {
        title: '유의사항',
        items: [
            '한화손보에 동일한 위험을 담보하는 다른 보험상품을 가입한 경우 가입이 제한됩니다.',
            '신청서에 입력된 발전소 소유주의 이메일로 가입안내문 및 가입증명서가 교부됩니다.',
            '제공된 개인정보는 동의없이 보험신청 외 다른 용도로 사용되지 않습니다.',
            '제공서비스 이외의 기타서비스를 요구할 수 없습니다.',
            '보험신청 및 보상관련 문의사항은 고객센터로 별도 연락 부탁드립니다.',
            '보험사는 상품에 대해 충분히 설명할 의무가 있으며, 가입자는 가입에 앞서 상품에 대한 충분한 설명을 받으시길 바랍니다.',
            '보험계약 체결 전 상품설명서 및 약관을 읽어보시길 바랍니다.',
            '보험계약자가 기존 보험계약을 해지하고 새로운 보험 계약을 체결할 때 보험인수거절이나 보장내용이 달라지거나 혹은 보험료가 인상될 수 있습니다. 지급한도, 면책사항 등의 사유에 따라 지급이 제한될 수 있습니다.',
            '이 보험계약은 예금자보호법에 따라 해약환급금(또는 만기 시 보험금)에 기타지급금을 합한 금액이 1인당 "1억원까지"(본 보험회사의 여타 보호상품과 합산)보호됩니다. 이와 별도로 본 보험회사 보호상품의 사고보험금을 합산한 금액이 1인당 "1억원까지" 보호됩니다. 다만, 보험계약자 및 보험료납부자가 법인인 보험계약의 경우에는 보호되지 않습니다.',
        ],
    },
];
export default function Section9() {
    return (_jsxs(Stack, { justifyContent: "center", alignItems: "center", bgcolor: "grey.200", padding: { xs: '60px 24px', md: '100px 24px 140px' }, children: [_jsx(Stack, { gap: "30px", maxWidth: 1392, width: "100%", children: contents.map(({ title, items }, i) => (_jsxs(Stack, { gap: "10px", children: [_jsx(Typography, { fontSize: { xs: 14, md: 20 }, fontWeight: 700, color: "#4A4A4A", children: title }), _jsx(List, { sx: {
                                listStyle: 'disc',
                                padding: 0,
                                '.MuiListItem-root': {
                                    display: 'list-item',
                                    fontSize: { xs: 14, md: 16 },
                                    fontWeight: 400,
                                    lineHeight: 1.6,
                                    whiteSpace: 'pre-line',
                                    color: '#4A4A4A',
                                    height: 'auto',
                                    marginLeft: 2,
                                    padding: 0,
                                },
                            }, children: items.map((item, j) => (_jsx(ListItem, { children: item }, j))) })] }, i))) }), _jsx(Box, { maxWidth: 1392, width: "100%", marginTop: "14px", marginLeft: { md: 4 }, children: _jsx(Typography, { fontSize: 12, fontWeight: 400, color: "grey.700", children: `확인필-제2026-에너지인프라-기타(광고)03562E-전사\n(26.07.23~27.07.22)` }) })] }));
}
